export const DEFAULT_STEP = 20000;
export const DEFAULT_MIN = 0;
export const DEFAULT_MAX = 1400000;
export const URL_PARAMETER_MIN = 'odometerFrom';
export const URL_PARAMETER_MAX = 'odometerTo';
